import React from 'react';
import { Container, Grid } from '@material-ui/core';
import { FaRegNewspaper } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { lang } from '../../config/app.config';
import translate from '../../translation.json';

const NewsTicker = (props) => {

  const { loading, news } = props;
  return (
    <>
      {news?.length > 0 ?
        <div style={{
          background: '#f2f2f2', boxShadow: '6px 0 15px rgba(0,0,0,0.16)'
        }}>
          <Container maxWidth="lg" >
            <div className="ecn-news-ticker">
              <Grid container>
                <Grid item xs={12} lg={2} md={2} className="ecn-news-ticker--header">
                  <FaRegNewspaper /> <span>{translate.translation[lang].latest_update}</span>
                </Grid>
                <Grid item xs={12} lg={10} md={10} className="ecn-news-ticker--news display-flex-ac">
                  {loading ? "" :
                    news && news.length ?
                      // eslint-disable-next-line
                      <marquee behavior="scroll" direction="left" scrollamount="5"> {/**eslint-disable-line*/}
                        <div style={{ display: 'flex' }}>
                          {news.map(n => {
                            return (
                              <div key={n.id} style={{ marginRight: '3em' }}>
                                {n?.type === 'news' ?
                                  <Link
                                    to={`/${lang}/news/${n?.slug}`}
                                    target="_blank"
                                    className="text-13-primary"
                                    style={{ color: 'black' }}
                                    title={n.title || ''}>
                                    <span className="text-14-secondary mr-05 bold">{'-'}</span>{
                                      n.title ? n.title
                                        : ''
                                    }</Link>
                                  :
                                  <a
                                    href={n?.value}
                                    target="_blank"
                                    className="text-13-primary"
                                    style={{ color: 'black' }}
                                  >
                                    <span className="text-14-secondary mr-05 bold">{'-'}</span>{
                                      n.title ? n.title
                                        : ''
                                    }
                                  </a>
                                }
                              </div>
                            )
                          })
                          }
                        </div>
                        {/* // eslint-disable-next-line */}
                      </marquee> /**eslint-disable-line*/
                      : ""
                  }
                </Grid>
              </Grid>
            </div>
          </Container>
        </div>
        : <></>}
    </>
  );
}

export default NewsTicker;